
function removePackageProtection(){
  jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
    updates: {
      42494188519671: 0
    }
  }).then(response => {
    // window.location.reload()
    $('.cart__item[data-id="42494188519671"]').remove()
  })
}

function addPackageProtection() {
    let formData = {
      'items': [{
      'id': 42494188519671,
      'quantity': 1
    }]
    }; 
    fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
    }).then(response => {
      response.json().then(data =>({
        data: data
      })).then(res =>{
        let protection_price = res.data.items[0].price / 100
        $(".cart__page-col[data-products]").prepend(`<div class="cart__item" data-id="42494188519671" data-key="42494188519671:da53f11701a3b9fcf816822cac947c11"><div class="cart__image">
        <a href="/products/heroine-sport-package-protection?variant=42494188519671" style="height: 0px; padding-bottom: 100%; font-size: 14px;" data-open-accessibility-text-original="14px" class="navigable">
          <img class="lazyautosizes lazyloaded" data-widths="[180, 360, 540]" data-aspectratio="" data-sizes="auto" alt="Heroine Sport Package Protection" data-srcset="//cdn.shopify.com/s/files/1/0496/6425/products/H-Logo-WHITE_2_180x.jpg?v=1647539720 180w, //cdn.shopify.com/s/files/1/0496/6425/products/H-Logo-WHITE_2_360x.jpg?v=1647539720 360w, //cdn.shopify.com/s/files/1/0496/6425/products/H-Logo-WHITE_2_540x.jpg?v=1647539720 540w" sizes="100px" srcset="//cdn.shopify.com/s/files/1/0496/6425/products/H-Logo-WHITE_2_180x.jpg?v=1647539720 180w, //cdn.shopify.com/s/files/1/0496/6425/products/H-Logo-WHITE_2_360x.jpg?v=1647539720 360w, //cdn.shopify.com/s/files/1/0496/6425/products/H-Logo-WHITE_2_540x.jpg?v=1647539720 540w">
    
          <noscript>
            <img class="lazyloaded" src="//cdn.shopify.com/s/files/1/0496/6425/products/H-Logo-WHITE_2_400x.jpg?v=1647539720" alt="Heroine Sport Package Protection">
          </noscript>
        </a>
      </div>
      <div class="cart__item-details">
        <div class="cart__item-title">
          <a href="/products/heroine-sport-package-protection?variant=42494188519671" class="cart__item-name navigable" data-open-accessibility-text-original="15px" style="font-size: 15px;">
            Heroine Sport Package Protection
          </a><div class="cart__item--variants">
              
            </div>
    
        </div>
        <div class="cart__item-sub">
          <div>
            <div class="js-qty__wrapper">
              <label for="cart_updates_42494188519671:da53f11701a3b9fcf816822cac947c11" class="hidden-label">Quantity</label>
              <input type="text" id="cart_updates_42494188519671:da53f11701a3b9fcf816822cac947c11" name="updates[]" class="js-qty__num" value="1" min="0" pattern="[0-9]*" data-id="42494188519671:da53f11701a3b9fcf816822cac947c11">
              <button type="button" class="js-qty__adjust js-qty__adjust--minus navigable" aria-label="Reduce item quantity by one">            
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>
                  <span class="icon__fallback-text" aria-hidden="true">−</span>
              </button>
              <button type="button" class="js-qty__adjust js-qty__adjust--plus navigable" aria-label="Increase item quantity by one">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>
                  <span class="icon__fallback-text" aria-hidden="true">+</span>
              </button>
            </div>
    
            <div class="cart__remove">
              <a href="/cart/change?id=42494188519671:da53f11701a3b9fcf816822cac947c11&amp;quantity=0" class="text-link navigable" data-open-accessibility-text-original="14px" style="font-size: 14px;">
                Remove
              </a>
            </div>
          </div>
    
          <div class="cart__item-price-col text-right">
            
              <span class="cart__price" data-open-accessibility-text-original="14px" style="font-size: 14px;">
                $${protection_price}
              </span>
            
    </div>
        </div>
      </div>
    </div>`)
      let package_protection_remove = $('div.cart__item[data-id="42494188519671"] .cart__item-sub .cart__remove a')
      $(package_protection_remove[0]).on('click', function(e){
        window.sessionStorage.setItem('package_protection', '1')
        e.preventDefault()
        removePackageProtection()
      })
      })
     
    })
  }
  
   // Get cart function needs to be added to onClick on quantity adjusters and add to cart forms
   function getCart(){
    setTimeout(function(){ 
      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemIds = cart.items.map(item => item.id)

        if (itemIds.includes(42494188519671)){
          if(cart.items.length == 1){
           removePackageProtection()
          }
        }else{
          if(cart.items.length == 1){
            if(window.sessionStorage.getItem('package_protection') == 0){
              addPackageProtection()
            }
          }else if(cart.items.length == 0){
            window.sessionStorage.setItem('package_protection', '0')
          }
        }

      })
    }, 1000);
  }
  
  
  document.addEventListener('DOMContentLoaded', () => {
    getCart()
    setTimeout(() => {
      let package_protection_remove = $('div.cart__item[data-id="42494188519671"] .cart__item-sub .cart__remove a')
      $(package_protection_remove[0]).on('click', function(e){
        window.sessionStorage.setItem('package_protection', '1')
        e.preventDefault()
        removePackageProtection()
      })
    }, 2000);

  })

  function updateCart() {
    const items = $(".cart__item")

    const itemIds = []
    for(let i = 0; i < items.length; i++){
      itemIds.push($(items[i]).attr('data-id'))
    }
    if (itemIds.includes('42494188519671')){
      let package_protection_remove = $('div.cart__item[data-id="42494188519671"] .cart__item-sub .cart__remove a')
      $(package_protection_remove[0]).on('click', function(e){
        window.sessionStorage.setItem('package_protection', '1')
        e.preventDefault()
        removePackageProtection()
      })
      if(itemIds.length == 1){
        removePackageProtection()
      }
    }else{
      if(itemIds.length == 1){
        if(window.sessionStorage.getItem('package_protection') == 0){
          addPackageProtection()
        }
      }else if(itemIds.length == 0){
        window.sessionStorage.setItem('package_protection', '0')
      }
    }
  }
 

  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      updateCart()     
    }, 1000);
  },false)

  document.addEventListener('ajaxProduct:added', () => {
    setTimeout(() => {
      updateCart()     
    }, 1000);
  },false)